import React from 'react';
import { useParams } from 'react-router-dom';

import { Box, Grid } from '@mui/material';

import Body from './Body';
import Navigation from './Navigation';

export default function WorkflowEventShow() {
  const { id } = useParams<{ id: string }>();
  if (!id) {
    throw new Error('Missing id');
  }

  return (
    <Box position="relative">
      <Box
        sx={{
          mb: 3,
          position: { lg: 'absolute' },
          top: (theme) => theme.spacing(-2),
          left: (theme) => theme.spacing(2),
        }}
      >
        <Navigation />
      </Box>
      <Grid container justifyContent="center" sx={{ my: 2 }}>
        <Grid item xs={12} md={10} sx={{ mb: 5, maxWidth: { md: 880 } }}>
          <Body id={id} />
        </Grid>
      </Grid>
    </Box>
  );
}
